import { VisuallyHidden } from "@99tech/ui";
import { Box, Stack } from "@mui/material";
import React, { useCallback, useContext } from "react";
import { AppDownload, LoginButton, Logo, RegisterButton, SlotGames } from "src/assets";
import { FloatingBanner } from "src/main/components";
import { AppContext } from "src/main/constants";
import { createStyles, isMobile } from "src/main/utils";

interface LandingPageProps extends React.PropsWithChildren {}

const LandingPage: React.FC<LandingPageProps> = (props) => {
  const { urls } = useContext(AppContext);
  const { loginUrl, registerUrl } = urls ?? {};

  const handleClick = useCallback(
    (type: "login" | "register") => (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (type === "login") {
        window.open(loginUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      } else {
        window.open(registerUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      }
    },
    [loginUrl, registerUrl],
  );

  return (
    <Box sx={styles.root}>
      <VisuallyHidden as="h1">Dee99</VisuallyHidden>

      <Box sx={{ position: "relative", width: 360, textAlign: "center" }}>
        <img
          alt="logo"
          src={Logo}
          style={{ width: 166, marginTop: "-36px" }}
        />
      </Box>

      <Stack
        direction="row"
        zIndex={10}
        mt={-1}
      >
        <a
          href={registerUrl}
          onClick={handleClick("register")}
          target="_blank"
          rel="noreferrer"
        >
          <img
            alt="register"
            src={RegisterButton}
            height={50}
          />
        </a>
        <a
          href={loginUrl}
          onClick={handleClick("login")}
          target="_blank"
          rel="noreferrer"
        >
          <img
            alt="login"
            src={LoginButton}
            height={50}
          />
        </a>
      </Stack>

      <img
        alt="slot games"
        src={SlotGames}
        style={{
          width: 360,
          marginTop: "-18px",
        }}
      />

      <img
        alt="app download"
        src={AppDownload}
        style={{
          width: 360,
          marginTop: "-38px",
        }}
      />

      <FloatingBanner />
    </Box>
  );
};

const styles = createStyles({
  root: {
    pt: "46px",
    pb: "20px",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    overflowX: "hidden",
  },
});

export default LandingPage;
